<template>
  <Modal
    :title="$t('edit_measurement_unit')"
    modalId="edit-modal"
    @submit="updateUnit"
  >
    <form @submit.prevent="updateUnit">
      <div class="mb-3">
        <label class="form-label">{{ $t('measurement_unit') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="unit.unit"
          class="form-control"
        />
        <!-- Error for unit -->
        <div v-if="errors.unit" class="text-danger mt-2">
          <span>{{ errors.unit }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedUnits: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      unit: {
        id: null,
        unit: '',
      },
      errorMessage: '',
      errors: {},
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  watch: {
    selectedUnits: {
      immediate: true,
      handler(newUnit) {
        if (newUnit && newUnit.id) {
          this.unit = { ...newUnit };
        }
      },
    },
  },
  methods: {
    async updateUnit() {
      try {
        const response = await this.$axios.patch(
          apiUrls.measurement_unit.update.replace(':pk', this.unit.id),
          { unit: this.unit.unit }
        );

        this.toast.success('Unit successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'unit' field is in errors and assign full error message
            if (error.response.data.unit && error.response.data.unit.length > 0) {
              // Assign the full error message from the array
              this.errors.unit = error.response.data.unit[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.unit = { id: null, unit: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>